import React from 'react';

export const EtcGrapeFlatIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.71484 15.1L12.931 12.0841C17.4686 10.4184 22.4974 12.7466 24.163 17.2843L15.9469 20.3002C11.4092 21.9658 6.38049 19.6376 4.71484 15.1Z"
        fill="#608842"
      />
      <path
        d="M26.2449 3.27355C27.0107 3.58966 27.3752 4.46667 27.0591 5.23242C26.0497 7.6777 24.8272 14.289 28.3104 20.3759C28.7219 21.0949 28.4725 22.0113 27.7535 22.4228C27.0345 22.8342 26.1181 22.5849 25.7066 21.8659C21.6321 14.7458 23.037 7.11339 24.2861 4.0877C24.6022 3.32196 25.4792 2.95745 26.2449 3.27355Z"
        fill="#96C34A"
      />
      <path
        d="M40.5812 38.7422C40.5812 42.1377 37.8286 44.8903 34.4332 44.8903C31.0377 44.8903 28.2852 42.1377 28.2852 38.7422C28.2852 35.3468 31.0377 32.5942 34.4332 32.5942C37.8286 32.5942 40.5812 35.3468 40.5812 38.7422Z"
        fill="#8C42B2"
      />
      <path
        d="M25.4004 30.5889C28.7958 30.5889 31.5488 33.3419 31.5488 36.7373C31.5487 38.7705 30.5601 40.5713 29.0391 41.6904C28.7071 41.0843 28.4741 40.4164 28.3623 39.708C27.894 39.8222 27.4048 39.8847 26.9014 39.8848C23.5061 39.8848 20.7532 37.1325 20.7529 33.7373C20.7529 33.6528 20.7554 33.5681 20.7588 33.4844C20.5432 33.5439 20.322 33.5886 20.0977 33.625C21.166 31.8085 23.1406 30.5889 25.4004 30.5889Z"
        fill="#551E72"
      />
      <path
        d="M26.9019 39.8851C30.2974 39.8851 33.0499 37.1326 33.0499 33.7371C33.0499 30.3417 30.2974 27.5891 26.9019 27.5891C23.5065 27.5891 20.7539 30.3417 20.7539 33.7371C20.7539 37.1326 23.5065 39.8851 26.9019 39.8851Z"
        fill="#8C42B2"
      />
      <path
        d="M34.6484 23.1067C38.0437 23.1069 40.7959 25.8598 40.7959 29.2551C40.7957 32.6503 38.0436 35.4024 34.6484 35.4026C31.2531 35.4026 28.5002 32.6504 28.5 29.2551C28.5 25.8597 31.253 23.1067 34.6484 23.1067Z"
        fill="#551E72"
      />
      <path
        d="M42.296 29.2549C42.296 32.6504 39.5435 35.403 36.148 35.403C32.7526 35.403 30 32.6504 30 29.2549C30 25.8595 32.7526 23.1069 36.148 23.1069C39.5435 23.1069 42.296 25.8595 42.296 29.2549Z"
        fill="#8C42B2"
      />
      <path
        d="M17.6201 24.4124C21.0155 24.4124 23.7685 27.1644 23.7686 30.5598C23.7686 32.6806 22.6942 34.5504 21.0605 35.6555C20.8624 35.0519 20.754 34.4074 20.7539 33.7375C20.7539 33.653 20.7564 33.5684 20.7598 33.4846C20.2376 33.6288 19.6881 33.7083 19.1201 33.7083C15.7247 33.7082 12.9727 30.9552 12.9727 27.5598C12.9727 27.1679 13.011 26.7849 13.0811 26.4133C14.2052 25.1834 15.8226 24.4124 17.6201 24.4124Z"
        fill="#551E72"
      />
      <path
        d="M25.2687 27.5601C25.2687 30.9556 22.5161 33.7081 19.1207 33.7081C15.7252 33.7081 12.9727 30.9556 12.9727 27.5601C12.9727 24.1647 15.7252 21.4121 19.1207 21.4121C22.5161 21.4121 25.2687 24.1647 25.2687 27.5601Z"
        fill="#8C42B2"
      />
      <path
        d="M26.0107 18.4595C29.4061 18.4595 32.159 21.2116 32.1592 24.6069C32.1592 28.0024 29.4062 30.7554 26.0107 30.7554C22.6154 30.7553 19.8633 28.0023 19.8633 24.6069C19.8633 23.5158 20.1479 22.4914 20.6465 21.603C20.9345 21.6765 21.2143 21.7707 21.4844 21.8833C21.6551 21.0382 21.9998 20.2564 22.4785 19.5757C23.478 18.8727 24.6959 18.4595 26.0107 18.4595Z"
        fill="#551E72"
      />
      <path
        d="M33.6593 23.107C33.6593 26.5024 30.9067 29.255 27.5113 29.255C24.1158 29.255 21.3633 26.5024 21.3633 23.107C21.3633 19.7115 24.1158 16.959 27.5113 16.959C30.9067 16.959 33.6593 19.7115 33.6593 23.107Z"
        fill="#8C42B2"
      />
      <path
        d="M37.6484 15.1338C38.9627 15.1339 40.1795 15.5475 41.1787 16.25C41.8817 17.2494 42.2958 18.4665 42.2959 19.7812C42.2959 21.6872 41.4278 23.3899 40.0664 24.5176C40.61 24.9678 41.0731 25.5111 41.4355 26.1211C40.3915 26.9393 39.0778 27.4296 37.6484 27.4297C34.253 27.4297 31.5 24.6767 31.5 21.2812C31.5001 17.8859 34.253 15.1338 37.6484 15.1338Z"
        fill="#551E72"
      />
      <path
        d="M36.148 25.9298C39.5435 25.9298 42.296 23.1773 42.296 19.7818C42.296 16.3863 39.5435 13.6338 36.148 13.6338C32.7526 13.6338 30 16.3863 30 19.7818C30 23.1773 32.7526 25.9298 36.148 25.9298Z"
        fill="#8C42B2"
      />
    </svg>
  );
};
